import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { DeleteFormVM, FormGroupedByCategoryVM, FormUploadVM, GetEditDigitalFormVM, IdNameVM, VMDataForUpload } from '../entities/global/model';
import { VMCreateCategory } from '../perform-induction/perform-induction';
import { Tuple } from '../setup-equipment/setup-equipment.model';
@Injectable()
export class SafetyFormsService {

  constructor(private _http: HttpClient) { }
  
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

// public GetFormsAndFormCategories(): Observable<FormsVM> {
//   return this._http.get('Api/SaftyForms/GetFormsAndFormCategories').share().map(
//       (response: Response) => <FormsVM>response.json()).catch(this.handleError);
// }

// public GetActiveFormsForDropDownList(): Observable<FormGroupedByCategoryVM[]> {
//   return this._http.get('api/SaftyForms/GetActiveFormsForDropDownList').share().map(
//     (response: Response) => <FormGroupedByCategoryVM[]>response.json()).catch(this.handleError);
// }
public GetActiveFormsForDropDownList(): Observable<FormGroupedByCategoryVM[]> {
  return this._http.get<FormGroupedByCategoryVM[]>('api/SaftyForms/GetActiveFormsForDropDownList').pipe(
    map((response: FormGroupedByCategoryVM[]) => response),
    catchError(this.handleError)
  );
}


// public GetActiveFormsForDropDownListisNotDigital(): Observable<FormGroupedByCategoryVM[]> {
//   return this._http.get('api/SaftyForms/GetActiveFormsForDropDownListisNotDigital').share().map(
//     (response: Response) => <FormGroupedByCategoryVM[]>response.json()).catch(this.handleError);
// }
public GetActiveFormsForDropDownListisNotDigital(): Observable<FormGroupedByCategoryVM[]> {
  return this._http.get<FormGroupedByCategoryVM[]>('api/SaftyForms/GetActiveFormsForDropDownListisNotDigital').pipe(
    map((response: FormGroupedByCategoryVM[]) => response),
    catchError(this.handleError)
  );
}


// public GetIncidentTypesForDropDownLists(): Observable<IdNameVM[]> {
//   return this._http.get('api/SaftyForms/GetIncidentTypesForDropDownLists').share().map(
//     (response: Response) => <IdNameVM[]>response.json()).catch(this.handleError);
// }
public GetIncidentTypesForDropDownLists(): Observable<IdNameVM[]> {
  return this._http.get<IdNameVM[]>('api/SaftyForms/GetIncidentTypesForDropDownLists').pipe(
    map((response: IdNameVM[]) => response),
    catchError(this.handleError)
  );
}


// public AddCompletedFormWithState(model:any): Observable<number> {
//   return this._http.post("api/SaftyForms/AddCompletedFormWithState",model ).share().map(
//     // return this._http.post("api/SaftyForms/AddCompletedFormWithState",{addForms: addForms, Formdata:Formdata} ).share().map(

//     (response: Response) => <number>response.json()).catch(this.handleError);
// }

public AddCompletedFormWithState(model: any): Observable<number> {
  return this._http.post<number>("api/SaftyForms/AddCompletedFormWithState", model).pipe(
    map((response: number) => response),
    catchError(this.handleError)
  );
}

//edit forms with state
// public EditCompletedFormWithState(addForms: FormUploadVM): Observable<Tuple> {
//   return this._http.post("api/SaftyForms/EditCompletedFormWithState", addForms).share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }

public EditCompletedFormWithState(addForms: FormUploadVM): Observable<Tuple> {
  return this._http.post<Tuple>("api/SaftyForms/EditCompletedFormWithState", addForms).pipe(
    map((response: Tuple) => response),
    catchError(this.handleError)
  );
}

//  public GetAdminLinkToAddUsers(): Observable<string> {
    
//     return this._http.get("api/SaftyForms/GetAdminLinkToAddUsers").share().map(
//       (response: Response) => <string>response.json()).catch(this.handleError);
//   }
public GetAdminLinkToAddUsers(): Observable<string> {
  return this._http.get<string>("api/SaftyForms/GetAdminLinkToAddUsers").pipe(
    map((response: string) => response),
    catchError(this.handleError)
  );
}

  // public Upload(Id:number): Observable<VMDataForUpload> {
  //   let options = {
  //     params: new HttpParams().set('Id', Id.toString())
  // };
  //   return this._http.get("api/SaftyForms/Upload", options).share().map(
  //     (response: Response) => <VMDataForUpload>response.json()).catch(this.handleError);
  // }
  
  public Upload(Id: number): Observable<VMDataForUpload> {
    let options = { params: new HttpParams().set('Id', Id.toString()) };
    return this._http.get<VMDataForUpload>("api/SaftyForms/Upload", options).pipe(
      map((response: VMDataForUpload) => response),
      catchError(this.handleError)
    );
  }
  
  // public DeleteForm(Id: number): Observable<boolean> {
  //   let params: URLSearchParams = new URLSearchParams();
  //   params.set('Id', "" + Id);
  //   return this._http.post("api/SaftyForms/DeleteForm", params).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }
  public DeleteForm(Id: number): Observable<boolean> {
    let params = new HttpParams().set('Id', Id.toString());
    return this._http.post<boolean>("api/SaftyForms/DeleteForm", { params }).pipe(
      map((response: boolean) => response),
      catchError(this.handleError)
    );
  }
  

  // public DeleteFormPaperForm(addForms: DeleteFormVM): Observable<boolean> {
  //   return this._http.post("api/SaftyForms/DeleteFormPaperForm", addForms).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }
  // public AddnewfFormCategory(_form: VMCreateCategory): Observable<boolean> {
  //   return this._http.post("api/SaftyForms/CreateCategory", _form).share().map(
  //     (response: Response) => <boolean>response.json()).catch(this.handleError);
  // }
  
public DeleteFormPaperForm(addForms: DeleteFormVM): Observable<boolean> {
  return this._http.post<boolean>("api/SaftyForms/DeleteFormPaperForm", addForms).pipe(
    map((response: boolean) => response),
    catchError(this.handleError)
  );
}

public AddnewfFormCategory(_form: VMCreateCategory): Observable<boolean> {
  return this._http.post<boolean>("api/SaftyForms/CreateCategory", _form).pipe(
    map((response: boolean) => response),
    catchError(this.handleError)
  );
}

  // public GETFormUpload_(Id:number): Observable<GetEditDigitalFormVM> {
  //   let params: URLSearchParams = new URLSearchParams();
  //   params.set('Id', "" + Id);
  //   return this._http.get("api/SafetyDigitalForm/GETFormUpload",{ search: params }).share().map(
  //     (response: Response) => <GetEditDigitalFormVM>response.json()).catch(this.handleError);
  // }

  public GETFormUploadData(FormId: number): Observable<GetEditDigitalFormVM> {
    let options = {
        params: new HttpParams().set('FormId', FormId.toString())
    };
    console.log("data", options,FormId)
    return this._http.get<GetEditDigitalFormVM>("api/SafetyDigitalForm/GETDigitalFormUpload", options).pipe(catchError(this.handleError));
}
 

  // public GetDataForForms(): Observable<Tuple> {
    
  //   return this._http.get("api/SaftyForms/GetDataForForms").share().map(
  //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
  // }
  
  public GetDataForForms(): Observable<Tuple> {
    return this._http.get<Tuple>("api/SaftyForms/GetDataForForms").pipe(
      map((response: Tuple) => response),
      catchError(this.handleError)
    );
  }
  

  public DownloadFormData(Id: number): Observable<GetEditDigitalFormVM> {
    let options = {
        params: new HttpParams().set('Id', Id.toString())
    };
    //console.log("data", options,Id)
    return this._http.get<GetEditDigitalFormVM>("api/SafetyDigitalForm/DownloadForm", options).pipe(catchError(this.handleError));
}

// public DownloadFormData(Id:number): Observable<GetEditDigitalFormVM> {
//   let params: URLSearchParams = new URLSearchParams();
//   params.set('Id', "" + Id);
//   return this._http.get("api/SafetyDigitalForm/DownloadForm",{ search: params }).share().map(
//     (response: Response) => <GetEditDigitalFormVM>response.json()).catch(this.handleError);
// }




  // public GetSelectedFormForDropDownList(Id:number): Observable<FormGroupedByCategoryVM> {
  //   let options = {
  //     params: new HttpParams().set('Id', Id.toString())
  // };
  //   return this._http.get("api/SafetyDigitalForm/GetSelectedFormForDropDownList", options).share().map(
  //     (response: Response) => <FormGroupedByCategoryVM>response.json()).catch(this.handleError);
  // }
  public GetSelectedFormForDropDownList(Id: number): Observable<FormGroupedByCategoryVM> {
    let options = { params: new HttpParams().set('Id', Id.toString()) };
  
    return this._http.get<FormGroupedByCategoryVM>("api/SafetyDigitalForm/GetSelectedFormForDropDownList", options).pipe(
      map((response: FormGroupedByCategoryVM) => response),
      catchError(this.handleError)
    );
  }
  
  
}
